import '../../../Mx/DataCollectionGroup/DataCollectionGroupPanel.css'

import React, { Component } from 'react'

import PhasingTree from './PhasingTree.js'
import PropTypes from 'prop-types'
import filter from 'lodash/filter'
import map from 'lodash/map'

export default class PhasingDataCollectionGroup extends Component {
  render() {
    if (this.props.fetching) {
      return 'Fetching'
    }

    return (
      <PhasingTree
        user={this.props.user}
        proposal={this.props.proposal}
        data={this.getTreeSteps(this.props.phasing, 'SAD')}
      />
    )
  }

  getTreeSteps(data, PhasingStep_method) {
    const sadRecords = filter(data[0], { PhasingStep_method: PhasingStep_method })
    const firstSteps = filter(sadRecords, { PhasingStep_previousPhasingStepId: null })

    map(firstSteps, function (step) {
      step.next = filter(sadRecords, { PhasingStep_previousPhasingStepId: step.PhasingStep_phasingStepId })
      map(step.next, function (substructureStep) {
        substructureStep.next = filter(sadRecords, {
          PhasingStep_previousPhasingStepId: substructureStep.PhasingStep_phasingStepId,
        })
        step.hasSubstructure = true
        map(substructureStep.next, function (phasingStep) {
          step.hasPhasing = true
          phasingStep.next = filter(sadRecords, {
            PhasingStep_previousPhasingStepId: phasingStep.PhasingStep_phasingStepId,
          })
          if (phasingStep.next.length > 0) {
            step.hasModel = true
          }
        })
      })
      return step
    })
    return firstSteps
  }

  parse(data, PhasingStep_method) {
    const sadRecords = filter(data[0], { PhasingStep_method: PhasingStep_method })
    const firstSteps = filter(sadRecords, { PhasingStep_previousPhasingStepId: null })

    map(firstSteps, function (step) {
      step.children = filter(sadRecords, { PhasingStep_previousPhasingStepId: step.PhasingStep_phasingStepId })
      map(step.children, function (substructureStep) {
        substructureStep.children = filter(sadRecords, {
          PhasingStep_previousPhasingStepId: substructureStep.PhasingStep_phasingStepId,
        })
        step.hasSubstructure = true
        map(substructureStep.children, function (phasingStep) {
          step.hasPhasing = true
          phasingStep.children = filter(sadRecords, {
            PhasingStep_previousPhasingStepId: phasingStep.PhasingStep_phasingStepId,
          })
          if (phasingStep.children.length > 0) {
            step.hasModel = true
          }
        })
      })
      return step
    })

    data[0] = filter(data[0], { PhasingStep_method: PhasingStep_method })
  }
}

PhasingDataCollectionGroup.propTypes = {
  user: PropTypes.object,
  proposal: PropTypes.string,
  dataCollectionGroupId: PropTypes.number,
}
